module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_3_1.1825d996.png";